import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { utils } from "@alife/cone-arms-core";
import { getTraceId, extendRequestAndResponseSizes } from "./utils";
export function hookMtop(core, config) {
    var detectMtop = // 处理返回信息
    // TODO当接口直接404、500时，不会走到这里
    function detectMtop(next) {
        var options = this.options;
        var params = this.params;
        var begin = new Date().getTime();
        return next().then(function() {
            var _options_retJson, _options_postdata, _params, _options_retJson1;
            var ret = options.retJson.ret;
            var duration = new Date().getTime() - begin;
            if (_instanceof(ret, Array)) {
                ret = ret.join(",");
            }
            var isFail = ret.indexOf("SUCCESS") === -1;
            // 因为在接口404、500等异常时不会走到中间键，这里默认200
            var status = options.retJson.code || 200;
            var responseHeaders = options.retJson.responseHeaders;
            // native中mtop请求受wv限制，responseHeaders不一定能透传traceid；mtop服务端升级Pandora版本到 2022-12-release 及之后的版本即可支持从 response body 里获取鹰眼id: http://pandora.alibaba-inc.com/pandora-web/sar/sarDetail.html?version=2022-12-release
            var eagleId = ((_options_retJson = options.retJson) === null || _options_retJson === void 0 ? void 0 : _options_retJson.traceId) || "";
            if (typeof responseHeaders === "string") {
                if (!eagleId) {
                    eagleId = getTraceId("mtop", responseHeaders, traceIdHeaderName);
                }
                var matchStatus = responseHeaders.match(/status:\s*(\d+)/);
                if (matchStatus) {
                    status = matchStatus[1];
                }
            }
            var code;
            var msg;
            if (ret) {
                var retArr = ret.split("::");
                code = retArr[0];
                msg = retArr[1];
            }
            var customRet;
            try {
                var _config;
                customRet = typeof ((_config = config) === null || _config === void 0 ? void 0 : _config.evaluate) === "function" ? config.evaluate(ret, ret, "mtop", options) : {};
            } catch (e) {
            // ignore error
            }
            // 入参
            var data = ((_options_postdata = options.postdata) === null || _options_postdata === void 0 ? void 0 : _options_postdata.data) || ((_params = params) === null || _params === void 0 ? void 0 : _params.data); // params?.data兜底。用户入参
            // 出差
            var response = JSON.stringify(((_options_retJson1 = options.retJson) === null || _options_retJson1 === void 0 ? void 0 : _options_retJson1.data) || {});
            var theLog = {
                api: params.api,
                success: !isFail,
                msg: msg,
                httpCode: status,
                code: code,
                time: duration,
                traceId: eagleId,
                // 允许上报才上传入参
                params: enableParams ? data : "",
                // 上报出入参的条件：请求失败，或者开启了全量上报
                response: isFail ? response : "",
                requestType: "mtop",
                sampling: !isFail && typeof sampling === "number" ? sampling : 1,
                bizSuccess: !isFail
            };
            extendRequestAndResponseSizes(theLog, data, options.retJson);
            if (typeof customRet === "object" && customRet !== null) {
                utils.shadowMerge(theLog, customRet);
            }
            core.logApi(theLog);
        }).catch(function() {
        // mtop监控报错
        });
    };
    var _ref = config || {}, _ref_enableParams = _ref.enableParams, enableParams = _ref_enableParams === void 0 ? true : _ref_enableParams, _ref_sampling = _ref.sampling, sampling = _ref_sampling === void 0 ? 0.1 : _ref_sampling, _ref_traceIdHeaderName = _ref.traceIdHeaderName, traceIdHeaderName = _ref_traceIdHeaderName === void 0 ? "" : _ref_traceIdHeaderName;
    if (!(window && window.lib)) {
        return;
    }
    if (window.lib.mtop && window.lib.mtop.middlewares) {
        window.lib.mtop.middlewares.push(detectMtop);
    } else {
        var mtop;
        Object.defineProperty(window.lib, "mtop", {
            set: function set(v) {
                mtop = v;
                if (mtop.middlewares) {
                    if (mtop.middlewares.indexOf(detectMtop) === -1) {
                        mtop.middlewares.push(detectMtop);
                    }
                } else {
                    var middlewares;
                    Object.defineProperty(mtop, "middlewares", {
                        set: function set(val) {
                            middlewares = val;
                            if (middlewares.indexOf(detectMtop) === -1) {
                                middlewares.push(detectMtop);
                            }
                        },
                        get: function get() {
                            return middlewares;
                        }
                    });
                }
            },
            get: function get() {
                return mtop;
            },
            configurable: true
        });
    }
    return function() {
        var _window_lib_mtop, _window_lib, _window;
        if ((_window = window) === null || _window === void 0 ? void 0 : (_window_lib = _window.lib) === null || _window_lib === void 0 ? void 0 : (_window_lib_mtop = _window_lib.mtop) === null || _window_lib_mtop === void 0 ? void 0 : _window_lib_mtop.middlewares) {
            var index = window.lib.mtop.middlewares.indexOf(detectMtop);
            if (index >= 0) {
                window.lib.mtop.middlewares.splice(index, 1);
            }
        }
    };
}
export default hookMtop;

 //# sourceMappingURL=hook-mtop.js.map